// Via ROUTES.TXT
const ROUTE_NAME_MAP = {
  1: 'Hudson',
  2: 'Harlem',
  3: 'New Haven',
  4: 'New Canaan',
  5: 'Danbury',
  6: 'Waterbury',
}

export const ROUTES_LIST = [
  {
    label: "Hudson",
    route_id: "1"
  },
  {
    label: "Harlem",
    route_id: "2"
  },
  {
    label: 'New Haven',
    route_id: '3'
  },
  {
    label: 'New Canaan',
    route_id: '4'
  },
  {
    label: 'Danbury',
    route_id: '5'
  },
  {
    label: 'Waterbury',
    route_id: '6'
  },
];
